<form novalidate [formGroup]="form">
  <input type="hidden" formControlName="id"/>

  <mat-form-field fxFlex="100">
    <mat-placeholder i18n>Description</mat-placeholder>
    <input matInput type="text" formControlName="description">
  </mat-form-field>

</form>
